import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/first-500-members")({
  component: () => <Navigate to="/first-500" replace />,
});
